import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FileUpload} from '../../models/file-upload.model';
import {FileItem, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {SessionQuery} from '../../../../stores/session/session.query';
import {environment} from '../../../../../../environments/environment';
import {AlertService} from '../../../alert/services/alert.service';

class MapModel {
  key: string;
  value: string;

  constructor(options?: any) {
    this.key = options && options.key;
    this.value = options && options.value;
  }
}

@Component({
  selector: 'app-upload-single-document',
  templateUrl: './upload-single-document.component.html',
  styleUrls: ['./upload-single-document.component.scss']
})
export class UploadSingleDocumentComponent implements OnInit {

  @ViewChild('fileInput', {static: true}) fileInput: ElementRef<HTMLInputElement>;

  @Input() label: string;
  @Input() additionalParameters: MapModel[];
  @Input() document: FileUpload;
  @Input() isReadOnly: boolean;
  @Input() showLabel = true;
  // @Input() direction: 'row' | 'col' = 'row';
  // @Input() deleteFile?: boolean;

  @Output() documentChange: EventEmitter<FileUpload> = new EventEmitter<FileUpload>();

  uploader: FileUploader;
  uploading = false;
  showDeleteConfirmModal: boolean;

  constructor(private sessionQuery: SessionQuery,
              private alertService: AlertService) {
  }

  ngOnInit() {
    this.showDeleteConfirmModal = false;
    this.uploaderInit();
  }

  uploaderInit() {
    const uploaderURL = `${environment.apiUrl}/upload/single`;

    this.uploader = new FileUploader({url: uploaderURL, autoUpload: true});

    this.uploader.onBeforeUploadItem = (item: FileItem) => {
      item.withCredentials = false;
      this.uploader.authToken = 'Basic ' + this.sessionQuery.getToken();
      if (this.additionalParameters && this.additionalParameters.length > 0) {
        this.additionalParameters.forEach(additionalParameter => {
          this.uploader.options.additionalParameter = {[additionalParameter.key]: additionalParameter.value};
        });
      }
      this.uploading = true;
    };

    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number) => {
      this.document = JSON.parse(response);
      this.uploading = false;
      this.documentChange.emit(this.document);
    };

    this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      this.uploading = false;

      if (status === 413 || response.includes('Maximum upload size exceeded')) {
        this.alertService.setAlert('File size exceeds maximum size (5MB) allowed.', 'error', 'uploadSingleDoc');
      } else {
        this.alertService.setAlert('An error occurred while uploading the file. [' + status + ']', 'error', 'uploadSingleDoc');
      }
    };
  }

  extractFileName(file) {
    if (file) {
      const splitString = file.split('/');
      return splitString[splitString.length - 1];
    }
    return '';
  }

  getDownloadUrl(file) {
    const fileName = this.extractFileName(file);
    return `${environment.apiUrl}/resources/ext/${fileName}`;
  }

  getFilename(document) {
    if (document && document.meta) {
      return document.meta.name;
    }
    return this.extractFileName(document);
  }

  downloadFile(doc) {
    fetch(this.getDownloadUrl(doc.value))
      .then(res => res.blob())
      .then(blob => {
        const a = document.createElement('a');
        const fileURL = URL.createObjectURL(blob);
        a.href = fileURL;
        a.download = this.getFilename(doc);
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
        URL.revokeObjectURL(fileURL);
      });
  }

  deleteConfirmation(isConfirmed: boolean) {
    this.showDeleteConfirmModal = false;
    if (isConfirmed) {
      this.document = undefined;
      this.fileInput.nativeElement.value = '';
      this.documentChange.emit(this.document);
    }
  }
}
